import { RegExpUtility } from "../../text/RegExpUtility";

export class ModifierKeys
{
  static readonly Shift = "Shift";
  static readonly Alt = "Alt";
  static readonly Meta = "Meta";
  static readonly Control = "Control";
  static readonly AltGraph = "AltGraph";
  static readonly CapsLock = "CapsLock";
  static readonly Fn = "Fn";
  static readonly Hyper = "Hyper";
  static readonly NumLock = "NumLock";
  static readonly ScrollLock = "ScrollLock";
  static readonly Super = "Super";
  static readonly SymbolLock = "SymbolLock";


  static readonly keys:string[] = 
  [
    ModifierKeys.Shift,
    ModifierKeys.Alt,
    ModifierKeys.Meta,
    ModifierKeys.Control,
    ModifierKeys.AltGraph,
    ModifierKeys.CapsLock,
    ModifierKeys.Fn,
    ModifierKeys.Hyper,
    ModifierKeys.NumLock,
    ModifierKeys.ScrollLock,
    ModifierKeys.Super,
    ModifierKeys.SymbolLock
  ];

  static readonly regex:RegExp = RegExpUtility.createMatcherFromCombiningWords( ModifierKeys.keys, true );
  
  static is( key:string )
  {
    return this.regex.test( key );
  }
}